import { Button, Center, Divider, Flex, Grid, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Text, VStack } from '@chakra-ui/react'
import GlucoseValues from './GlucoseValues'
import { useGetGlucose } from 'hooks/useGlucoseRegister'
import dateFormat from 'functions/dateFormat'
import { useNavigate } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { GET_GLUCOSE_REPORT } from 'queries/reportQueries'
import { downloadBinaryReport } from 'functions/reports'
import { DownloadIcon } from '@phosphor-icons/react'

interface Props {
    isOpen: boolean
    onClose: () => void,
    id: string
}

const ViewMonitoring = ({ isOpen, onClose, id }: Props) => {
    const { data, loading } = useGetGlucose(id);
    const [getReport, { loading: loadingReport }] = useLazyQuery(GET_GLUCOSE_REPORT, {
        fetchPolicy: 'no-cache'
    });
    const navigate = useNavigate()

    const glucose = data?.getGlucose || { glucose_monitoring: [] };
    const glucose_monitoring = [...glucose.glucose_monitoring]

    const NavToProfile = (life_id: string) => {
        navigate(`/administracao/vidas/${life_id}`);
    }

    const onDownload = async () => {
        const { getGlucose } = data;
        const { registration_number } = getGlucose;

        const { data: reportData } = await getReport({
            variables: {
                registration_number,
                withDateLimit: false
            }
        });
        const report = reportData.getGlucoseReport;

        const filename = report.filename;
        const content = report.content;

        downloadBinaryReport(filename, content)
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text>Monitoramento de Glicemia</Text>
                </ModalHeader>
                <ModalBody>
                    <Flex w="full" h="full" mb={6} >
                        {
                            loading ?
                                <Center h="full" w="full">
                                    <Spinner size="lg" />
                                </Center>
                                :
                                <Grid templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }} w="full" gridGap={4}>
                                    <VStack textAlign="left">
                                        <Text fontSize="lg">Nome</Text>
                                        <Text fontSize="lg" fontWeight="bold">{glucose.name}</Text>
                                    </VStack>
                                    <VStack textAlign="left">
                                        <Text fontSize="lg">Nº Carteirinha</Text>
                                        <Text fontSize="lg" fontWeight="bold">{glucose.registration_number}</Text>
                                    </VStack>
                                    <VStack textAlign="left">
                                        <Text fontSize="lg">CPF</Text>
                                        <Text fontSize="lg" fontWeight="bold">{glucose.cpf}</Text>
                                    </VStack>
                                    <VStack textAlign="left">
                                        <Text fontSize="lg">Telefone</Text>
                                        <Text fontSize="lg" fontWeight="bold">{glucose.phone}</Text>
                                    </VStack>
                                    <VStack textAlign="left">
                                        <Text fontSize="lg">Estado</Text>
                                        <Text fontSize="lg" fontWeight="bold">{glucose.state?.toUpperCase()}</Text>
                                    </VStack>
                                    <VStack textAlign="left">
                                        <Text fontSize="lg">Data de Cadastro</Text>
                                        <Text fontSize="lg" fontWeight="bold">{dateFormat(glucose.created_at, "dd/MM/yyyy HH:mm:ss")}</Text>
                                    </VStack>
                                </Grid>
                        }
                    </Flex>
                    {
                        loading ? <></>
                        :
                        <Flex w="full" justifyContent="center" py={4}>
                            {glucose.life_id 
                                ? <Button onClick={() => NavToProfile(glucose.life_id)} colorScheme="green">Acessar Perfil</Button> 
                                : "Perfil não encontrado nos registros"
                            }
                        </Flex>
                    }
                    <Flex w="full" flexDirection="column">
                        {
                            loading ? <></>
                                :
                                <>
                                    <Text fontSize="lg" fontWeight="bold" mb="4">Registros</Text>
                                    <VStack gap={2} maxH="220px" overflowY="auto" divider={<Divider />}>
                                        {
                                            glucose_monitoring.length == 0 ? <Text fontSize="md">Sem registros.</Text>
                                                :
                                                glucose_monitoring
                                                    .sort((a: any, b: any) => new Date(b.created_at).valueOf() - new Date(a.created_at).valueOf())
                                                    .map((values: any) => <GlucoseValues {...values} />)
                                        }
                                    </VStack>
                                </>
                        }
                    </Flex>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button colorScheme='green' onClick={onDownload} isLoading={loadingReport} leftIcon={<DownloadIcon weight="bold" />} >Exportar Dados</Button>
                    <Button colorScheme="red" onClick={onClose} >Fechar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ViewMonitoring